import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSocketPrinter } from '../hooks/useSocketPrinter';
import { posHasCurrentAgencySelector } from 'src/features/pos';
import { useZebraPrinter } from './useZebraPrinter';
import { useTranslation } from 'react-i18next';
import { PosAgencySelector } from 'src/containers/PosAgencySelector';
import { PrintIndicatorSteps } from './components/PrintIndicatorSteps';
import { DocumentPrintPayload } from '../printer.types';
import { QueuedPrinter } from './components/QueuedPrinter';
import { addQueueToPrinter, removeQueueFromPrinter } from '../store';
import { PrinterOnDemand } from './components/PrinterOnDemand';
import { SText } from 'src/components/SText';
import { IdModel } from 'src/types';

type Props = {};

export const PrinterPageContainer: React.FC<Props> = ({}): JSX.Element => {
  const {
    printIsReady,
    browserPrint,
    error: errorPrinter,
  } = useZebraPrinter();

  const hasPosAgency = useSelector(posHasCurrentAgencySelector);
  const [lastPrinted, setLastPrinted] = useState<IdModel | null>(null);
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const onPrintRequest = useCallback(
    async (document: DocumentPrintPayload) => {
      if (browserPrint) {
        const status = await browserPrint.checkPrinterStatus();
        if (status.isReadyToPrint) {
          browserPrint.print(document.doc);
        } else {
          dispatch(addQueueToPrinter({ queue: { ...document, date: new Date().toString() } }));
        }
      } else {
        // console.log('Cant print please verify your print and reprint data');
        // console.log('Will make job for ', doc );
      }
    },
    [browserPrint, dispatch],
  );
  const { connectedToServer, socketError } = useSocketPrinter(onPrintRequest);
 

  const onPrint = useCallback(
    async (doc: string, id: IdModel) => {
      if (browserPrint){
        try {
          await browserPrint.print(doc);
          if (id) {
            dispatch(removeQueueFromPrinter({ id }));
            setLastPrinted(id)
          }
        } catch (e) {
          alert("Impossible d'imprimer merci de vérifier votre imprimante");
          console.error('Error while print doc > ', e);
        }
      }
    },
    [browserPrint, dispatch, setLastPrinted],
  );

  return (
    <div className="p-10 bg-white min-h-screen">
      <div className=" w-1/2 mt-4 md:mt-10">
        <h2 className="my-4 text-primary text-md font-semibold ">{t('pos.current-agency')}</h2>
        <PosAgencySelector />
      </div>

      {hasPosAgency && (
        <div>
          <div className="flex flex-col items-center">
            <div className="flex  my-4 md:my-8">
              <SText label="printer.print-settings" classNames="font-semibold text-gray-600" />
            </div>
            <div className="my-4 md:w-2/3">
 
                <PrintIndicatorSteps
                  printIsReady={printIsReady}
                  printErrors={errorPrinter}
                  socketConnected={connectedToServer}
                  socketError={socketError}
                  hasPosAgency={hasPosAgency}
                />

            </div>
          </div>
          <div>
            <QueuedPrinter printerIsReady={printIsReady} onPrint={onPrint}/>
          </div>

          <div className="my-4 border-t border-gray-300">
            <PrinterOnDemand printerIsReady={printIsReady} onPrint={onPrint} lastPrinted={lastPrinted}/>
          </div>
        </div>
      )}
    </div>
  );
};
